(function () {
  'use strict';

  if (window.UnifiedShopifyBridgeConsumer) {
    return;
  }

  const VERSION = '1.0.0';

  function getBridgeConfig() {
    return (
      window.UnifiedProjectConfig &&
      window.UnifiedProjectConfig.bridge
    ) || {
      queueKey: 'ut_shopify_event_queue',
      ttlMs: 7 * 24 * 60 * 60 * 1000,
      maxEvents: 100
    };
  }

  function hasConsent() {
    return Boolean(
      window.UnifiedConsent &&
      typeof window.UnifiedConsent.analyticsAllowed === 'function' &&
      window.UnifiedConsent.analyticsAllowed() === true
    );
  }

  function parseQueue(rawValue) {
    if (!rawValue) return [];

    try {
      const parsed = JSON.parse(rawValue);
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      return [];
    }
  }

  function readQueue() {
    const config = getBridgeConfig();

    try {
      return parseQueue(window.localStorage.getItem(config.queueKey));
    } catch (error) {
      return [];
    }
  }

  function writeQueue(queue) {
    const config = getBridgeConfig();

    try {
      window.localStorage.setItem(
        config.queueKey,
        JSON.stringify(Array.isArray(queue) ? queue : [])
      );
      return true;
    } catch (error) {
      return false;
    }
  }

  function isFresh(entry, ttlMs, nowMs) {
    if (!entry || !entry.id || !entry.canonical_event || !entry.source_event) {
      return false;
    }

    const timestamp = Date.parse(entry.source_timestamp || '');

    if (!Number.isFinite(timestamp)) {
      return false;
    }

    return nowMs - timestamp <= ttlMs && timestamp <= nowMs + 60 * 1000;
  }

  function getClassification(product) {
    const source = product && typeof product === 'object' ? product : {};
    const hasProductIdentity = Boolean(
      source.product_sku ||
      source.variant_id ||
      source.product_id
    );

    if (!hasProductIdentity) {
      return {};
    }

    if (
      window.UnifiedProductContext &&
      typeof window.UnifiedProductContext.classifyItem === 'function'
    ) {
      return window.UnifiedProductContext.classifyItem(source);
    }

    return {};
  }

  function dispatchClarityOnly(eventName) {
    if (!hasConsent()) return false;

    const manager = window.UnifiedProviderManager;

    if (!manager || typeof manager.dispatch !== 'function') {
      return false;
    }

    const result = manager.dispatch(
      eventName,
      {},
      {
        routes: ['clarity'],
        payloads: {
          clarity: {}
        },
        metadata: {
          origin: 'shopify_native_marker'
        }
      }
    );

    return Boolean(result && result.delivered);
  }

  function consumeQueue() {
    if (!hasConsent()) {
      return [];
    }

    const journey = window.UnifiedJourney;
    const bus = window.UnifiedBus;

    if (!journey || typeof journey.addExternalStep !== 'function') {
      return [];
    }

    const config = getBridgeConfig();
    const nowMs = Date.now();
    const queue = readQueue();
    const seen = new Set();
    const remaining = [];
    const consumed = [];

    queue.forEach(function (entry) {
      if (!isFresh(entry, config.ttlMs, nowMs)) {
        return;
      }

      if (seen.has(entry.id)) {
        return;
      }

      seen.add(entry.id);

      try {
        const product = entry.product && typeof entry.product === 'object'
          ? entry.product
          : {};

        const commerce = entry.commerce && typeof entry.commerce === 'object'
          ? entry.commerce
          : {};

        const attribution = entry.attribution && typeof entry.attribution === 'object'
          ? entry.attribution
          : {};

        const classification = getClassification(product);

        const payload = Object.assign(
          {
            origin: 'shopify_native',
            source_event: entry.source_event,
            source_timestamp: entry.source_timestamp
          },
          product,
          commerce,
          classification,
          attribution
        );

        journey.addExternalStep(
          entry.canonical_event,
          payload,
          entry.source_timestamp
        );

        if (bus && typeof bus.emit === 'function') {
          bus.emit('shopify_native_event_consumed', {
            event: entry.canonical_event,
            source_event: entry.source_event,
            source_timestamp: entry.source_timestamp,
            product_sku: payload.product_sku || '',
            item_class: payload.item_class || ''
          });
        }

        consumed.push(entry.id);

        if (entry.source_event === 'checkout_started') {
          dispatchClarityOnly('checkout_started');
        }

        if (entry.source_event === 'checkout_completed') {
          dispatchClarityOnly('purchase');
        }
      } catch (error) {
        remaining.push(entry);
      }
    });

    writeQueue(remaining.slice(-config.maxEvents));

    return consumed;
  }

  function initialize() {
    consumeQueue();
  }

  window.UnifiedShopifyBridgeConsumer = {
    version: VERSION,
    consumeQueue: consumeQueue,
    getQueue: readQueue
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }

  window.addEventListener('pageshow', initialize);
})();
